import { Avatar } from 'primeng/avatar';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { Fieldset } from 'primeng/fieldset';
import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';

import { RoleCode } from '../../models/user/user.enums';
import { RoleColorsUtil } from '../../utils/role-colors.util';

/** Candidate for account selection during external auth link flow. */
export interface LinkAccountCandidate {
	id: number;
	username: string;
	fullName: string;
	roles: RoleCode[];
}

@Component({
	selector: 'app-select-link-account-dialog',
	templateUrl: './select-link-account-dialog.component.html',
	imports: [Dialog, Button, Fieldset, Avatar],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectLinkAccountDialogComponent {
	public visible = model<boolean>(false);

	public loading = input<boolean>(false);
	public candidates = input<LinkAccountCandidate[]>([]);
	/** Provider name for display (e.g. 'Azure AD' or 'MSA'). */
	public providerLabel = input<string>('account');

	public cancelled = output<void>();
	public accountSelected = output<LinkAccountCandidate>();

	/**
	 * Gets the first letter of the username for avatar display.
	 *
	 * @param {string} username - The username to get initial from.
	 * @return {string} The first letter uppercased.
	 */
	public getInitial(username: string): string {
		return username ? username.charAt(0).toUpperCase() : 'U';
	}

	/**
	 * Gets the avatar style based on user's first role.
	 *
	 * @param {RoleCode[]} roles - The user roles.
	 * @return {Record<string, string>} Style object with background color.
	 */
	public getAvatarStyle(roles: RoleCode[]): Record<string, string> {
		const primaryRole = roles[0] || RoleCode.SUPERVISOR;
		return {
			'background-color': RoleColorsUtil.getRoleColor(primaryRole),
			color: 'white'
		};
	}

	/**
	 * Closes the dialog and emits cancelled event.
	 */
	public closeDialog(): void {
		this.visible.set(false);
		this.cancelled.emit();
	}

	/**
	 * Handles account selection.
	 *
	 * @param {LinkAccountCandidate} candidate - The selected candidate.
	 */
	public selectAccount(candidate: LinkAccountCandidate): void {
		this.accountSelected.emit(candidate);
	}
}
